import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as ActivityActions from '../actions/activity.action';
import { PostActivityService } from '../../../apis/post-activity.service';
import { FarmPostActivity, PostActivity } from 'src/app/models/PostActivity.model';

@Injectable()
export class ActivityEffects {
  loadActivities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActivityActions.loadActivities),
      mergeMap(() =>
        this.postActivityService.getFarmActivities().pipe(
          map((activities: PostActivity[]) =>
            ActivityActions.loadActivitiesSuccess({ activities })
          ),
          catchError((error) =>
            of(ActivityActions.loadActivitiesFailure({ error }))
          )
        )
      )
    )
  );

  addActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActivityActions.addActivity),
      mergeMap((action) =>
        this.postActivityService.addActivity(action.activity, action.production_list).pipe(
          map((activity: PostActivity[]) => ActivityActions.addActivitySuccess({ activity })),
          catchError((error) => of(ActivityActions.addActivityFailure({ error })))
        )
      )
    )
  );

  deleteActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActivityActions.deleteActivity),
      mergeMap((action) =>
        this.postActivityService.deleteActivity(action.id).pipe(
          map(() =>
            ActivityActions.deleteActivitySuccess({ activityId: action.activity_id, id: action.id })
          ),
          catchError((error) =>
            of(ActivityActions.deleteActivityFailure({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private postActivityService: PostActivityService,
  ) {}
}